import { useTranslation } from '@gimlite/common';
import {
  Timeline,
  TimelineType,
} from '../../components/timeline/timeline.component';

export declare namespace ExitAuthorizedSessionTimelineType {
  type Props = {
    data: {
      date: TimelineType.Data.Date;
      extra: TimelineType.Data.Extra;
      device: TimelineType.Data.Device;
    };
  };
}

export const ExitAuthorizedSessionTimeline = ({
  data: { date, extra, device },
}: ExitAuthorizedSessionTimelineType.Props) => {
  const { t } = useTranslation();
  return (
    <Timeline
      config={{
        color: 'success',
      }}
      data={{
        icon: 'faCarSolid',
        date,
        device,
        title: t('global-state-exit-authorized'),
        extra,
      }}
    />
  );
};
